import React, { createContext, useContext, useState, useEffect } from "react";
import { api, apiErr } from "../lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    api.get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => setUser(null))
      .finally(() => setChecking(false));
  }, []);

  const login = async (email, password, code = "") => {
    const { data } = await api.post("/auth/login", { email, password, code });
    if (data.mfa_required) return { mfaRequired: true, sentTo: data.sent_to || "" };
    setUser(data.user);
    return { user: data.user };
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch (e) { console.debug("logout request failed (ignored)", e); }
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, checking, login, logout, apiErr }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
